const PRE_SEASON = 1;
const REGULAR_SEASON = 2;
const PLAYOFFS = 3;

const gameTypeSelectOptions = [
    {
        label: 'Regular Season',
        value: REGULAR_SEASON
    },
    {
        label: 'Playoffs',
        value: PLAYOFFS
    }
];

export default {
    PRE_SEASON,
    REGULAR_SEASON,
    PLAYOFFS,
    gameTypeSelectOptions
};
